// auto-generated by Typewriter template _models.tst from PortCall.EndPoints\Api\PortCallDeletion\ApiPortCallDeletion.cs
import S, { DataSignal } from 's-js';
import SArray, { SDataArray } from 's-array';
import TZDate from 'lib/TZDate';
import { jsonableObservable } from 'lib/jsonableObservable';
import { Berth, BerthData, BerthOptions } from 'data/models/Berth';
import { Event, EventData, EventOptions } from 'data/models/Event';
import { NullableMeasurement, NullableMeasurementData, NullableMeasurementOptions } from 'data/models/Measurement';
import { PCUser, PCUserData, PCUserOptions } from 'data/models/PCUser';
import { RecurringBatchChange, RecurringBatchChangeData, RecurringBatchChangeOptions } from 'data/models/RecurringBatchChange';
import { RecurringBatchDeletion, RecurringBatchDeletionData, RecurringBatchDeletionOptions } from 'data/models/RecurringBatchDeletion';
import { Vessel, VesselData, VesselOptions } from 'data/models/Vessel';

// PortCallDeletionData is the class that PortCallDeletion serializes to/from
export interface PortCallDeletionData {
    Id : number;
	
    Berth : BerthData | null;
    BerthId : number;
    Event : EventData | null;
    EventId : number;
    RecurringBatchChange : RecurringBatchChangeData | null;
    RecurringBatchChangeId : number | null;
    RecurringBatchDeletion : RecurringBatchDeletionData | null;
    RecurringBatchDeletionId : number | null;
    Requestor : PCUserData | null;
    RequestorId : number;
    Vessel : VesselData | null;
    VesselId : number | null;
	
    FirstLine : /* ISO8601 */ string;
    LastLine : /* ISO8601 */ string;
    LengthOnlyLength : NullableMeasurementData;
    PortCallGuid : /* GUID */ string;
    RecurringBatchGuid : /* GUID */ string | null;
    RecurringBatchReferenceNumber : string | null;
}

// PortCallDeletionOptions is the class which may be passed to the PortCallDeletion constructor to define optional initial data values
export interface PortCallDeletionOptions {
    Id : number;
	
    Berth? : BerthOptions | null;
    BerthId? : number;
    Event? : EventOptions | null;
    EventId? : number;
    RecurringBatchChange? : RecurringBatchChangeOptions | null;
    RecurringBatchChangeId? : number | null;
    RecurringBatchDeletion? : RecurringBatchDeletionOptions | null;
    RecurringBatchDeletionId? : number | null;
    Requestor? : PCUserOptions | null;
    RequestorId? : number;
    Vessel? : VesselOptions | null;
    VesselId? : number | null;
	
    FirstLine? : /* ISO8601 */ string;
    LastLine? : /* ISO8601 */ string;
    LengthOnlyLength? : NullableMeasurementOptions;
    PortCallGuid? : /* GUID */ string;
    RecurringBatchGuid? : /* GUID */ string | null;
    RecurringBatchReferenceNumber? : string | null;
}

export class PortCallDeletion {
    public Id : DataSignal<number>;
	
    public Berth : DataSignal<Berth | null>;
    public BerthId : DataSignal<number>;
    public Event : DataSignal<Event | null>;
    public EventId : DataSignal<number>;
    public RecurringBatchChange : DataSignal<RecurringBatchChange | null>;
    public RecurringBatchChangeId : DataSignal<number | null>;
    public RecurringBatchDeletion : DataSignal<RecurringBatchDeletion | null>;
    public RecurringBatchDeletionId : DataSignal<number | null>;
    public Requestor : DataSignal<PCUser | null>;
    public RequestorId : DataSignal<number>;
    public Vessel : DataSignal<Vessel | null>;
    public VesselId : DataSignal<number | null>;
	
    public FirstLine : DataSignal<TZDate>;
    public LastLine : DataSignal<TZDate>;
    public LengthOnlyLength : NullableMeasurement;
    public PortCallGuid : DataSignal<string>;
    public RecurringBatchGuid : DataSignal<string | null>;
    public RecurringBatchReferenceNumber : DataSignal<string | null>;

    constructor();
    constructor(data : PortCallDeletionOptions);
    constructor(data: PortCallDeletionOptions | null = null) {
        this.Id = jsonableObservable(S.value<number>(data && data.Id !== undefined ? data.Id : 0));
	    
        this.Berth = S.value<Berth | null>(null);
        this.BerthId = jsonableObservable(S.value<number>(data && data.BerthId !== undefined ? data.BerthId : 0));
        this.Event = S.value<Event | null>(null);
        this.EventId = jsonableObservable(S.value<number>(data && data.EventId !== undefined ? data.EventId : 0));
        this.RecurringBatchChange = S.value<RecurringBatchChange | null>(null);
        this.RecurringBatchChangeId = jsonableObservable(S.value<number | null>(data && data.RecurringBatchChangeId !== undefined ? data.RecurringBatchChangeId : null));
        this.RecurringBatchDeletion = S.value<RecurringBatchDeletion | null>(null);
        this.RecurringBatchDeletionId = jsonableObservable(S.value<number | null>(data && data.RecurringBatchDeletionId !== undefined ? data.RecurringBatchDeletionId : null));
        this.Requestor = S.value<PCUser | null>(null);
        this.RequestorId = jsonableObservable(S.value<number>(data && data.RequestorId !== undefined ? data.RequestorId : 0));
        this.Vessel = S.value<Vessel | null>(null);
        this.VesselId = jsonableObservable(S.value<number | null>(data && data.VesselId !== undefined ? data.VesselId : null));
	    
        this.FirstLine = jsonableObservable(S.value<TZDate>(data && data.FirstLine !== undefined ? new TZDate(data.FirstLine) : new TZDate(0), TZDate.eq));
        this.LastLine = jsonableObservable(S.value<TZDate>(data && data.LastLine !== undefined ? new TZDate(data.LastLine) : new TZDate(0), TZDate.eq));
        this.LengthOnlyLength = data && data.LengthOnlyLength !== undefined ? new NullableMeasurement(data.LengthOnlyLength) : new NullableMeasurement();
        this.PortCallGuid = jsonableObservable(S.value<string>(data && data.PortCallGuid !== undefined ? data.PortCallGuid : '00000000-0000-0000-0000-000000000000'));
        this.RecurringBatchGuid = jsonableObservable(S.value<string | null>(data && data.RecurringBatchGuid !== undefined ? data.RecurringBatchGuid : null));
        this.RecurringBatchReferenceNumber = jsonableObservable(S.value<string | null>(data && data.RecurringBatchReferenceNumber !== undefined ? data.RecurringBatchReferenceNumber : null));
    }

    static key(obj : PortCallDeletion) {
        return obj.Id();
    }
    
    static dataKey(obj : PortCallDeletionOptions) {
        return obj.Id;
    }

    static update(obj : PortCallDeletion, data : PortCallDeletionOptions) {
        S.freeze(() => {
            if (data.Id !== undefined) obj.Id(data.Id);
	        
            if (data.BerthId !== undefined) obj.BerthId(data.BerthId);
            if (data.EventId !== undefined) obj.EventId(data.EventId);
            if (data.RecurringBatchChangeId !== undefined) obj.RecurringBatchChangeId(data.RecurringBatchChangeId);
            if (data.RecurringBatchDeletionId !== undefined) obj.RecurringBatchDeletionId(data.RecurringBatchDeletionId);
            if (data.RequestorId !== undefined) obj.RequestorId(data.RequestorId);
            if (data.VesselId !== undefined) obj.VesselId(data.VesselId);
	        
            if (data.FirstLine !== undefined) obj.FirstLine(new TZDate(data.FirstLine));
            if (data.LastLine !== undefined) obj.LastLine(new TZDate(data.LastLine));
            if (data.LengthOnlyLength !== undefined) NullableMeasurement.update(obj.LengthOnlyLength, data.LengthOnlyLength);
            if (data.PortCallGuid !== undefined) obj.PortCallGuid(data.PortCallGuid);
            if (data.RecurringBatchGuid !== undefined) obj.RecurringBatchGuid(data.RecurringBatchGuid);
            if (data.RecurringBatchReferenceNumber !== undefined) obj.RecurringBatchReferenceNumber(data.RecurringBatchReferenceNumber);
        });
    }
}



// WEBPACK FOOTER //
// ./server/models/PortCallDeletion.ts